import React from "react";
import Applet from "../../Applet";
import AdminOrganizationPositionTable from "../../../../components/Administration/AdminOrganizationPositionTable";

class AdminOrganizationPositionTableApplet extends Applet {

    render() {
        return <AdminOrganizationPositionTable applet={this}
                                   pageSize={this.state.PageSize}
                                   placement={this.state.Placement}
                                   columns={this.state.Columns}
                                   title="Positions"
                                   enterpriseComponent={this.getEnterpriseComponent()}
                                   sort={this.state.Sort}
                                   menu={this.state.Menu}
                                   rowHeight={this.state.RowHeight}
                                   simpleSearch={this.state.SimpleSearch}
        />;
    }

    state = {
        Name: "AdminOrganizationPositionTableApplet",
        Menu: {
            options: [
                {
                    displayValue: "Add Position To Organization",
                    value: "New Position",
                },
                {
                    displayValue: "Refresh",
                    value: "Refresh",
                },
            ],
        },
        RowHeight: 60,
        PageSize: {
            "default": 5,
            "xs": 3,
            "sm": 3,
            "md": 10,
            "lg": 10,
            "lx": 10,
        },
        Placement: {
            "xl": [
                {
                    id: "RecordPointer",
                },
                {
                    id: "Name",
                },
                {
                    id: "ParentPositionName",
                },
                {
                    id: "PrimaryEmployeeName",
                },
                {
                    id: "Actions",
                },
            ],
        },
        Columns: [
            {
                id: "RecordPointer",
                width: 25,
                cellRenderer: "Row Selection Indicator Cell",
                header: null,
                headerRenderer: "",
                headerTitle: "",
            },
            {
                id: "Name",
                width: 325,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Name",
            },
            {
                id: "ParentPositionName",
                width: 325,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Parent Position Name",
            },
            {
                id: "PrimaryEmployeeName",
                width: 250,
                cellRenderer: "Employee Name Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Primary Employee",
            },
            {
                id: "Actions",
                width: 50,
                cellRenderer: "Action Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "",
                pinned: "right",
                hideable: false,
            },
        ],
        Sort: [
            {
                "Identifier": 1,
                "Visible": true,
                "Default": true,
                "Options": [{
                    "Direction": "ASC",
                    "SortAttribute": "Name",
                    "DisplayName": "Name",
                }],
            },
        ],
        SimpleSearch: {
            Actions: {
                Query: {
                    Groups: [
                        {
                            "identifier": "group1",
                            "type": "standard",
                            "selector": null,
                            "characteristics": [],
                            "membership": [
                                {
                                    id: "Name",
                                }
                            ]
                        }
                    ]
                }
            },
            Controls: {
                "Name": {
                    id: "Name",
                    enterpriseComponentAttribute: "Name",
                    placement: {
                        "Query": {
                            xs: 12,
                            sm: 6,
                            md: 6,
                            lg: 3,
                            xl: 3
                        }
                    },
                    errors: [
                        {
                            validator: "No Special Characters",
                            value: null,
                            errorText: "Field must not have special characters.",
                        },
                        {
                            validator: "No Leading Spaces",
                            value: null,
                            errorText: "Field must not have leading spaces.",
                        },
                        {
                            validator: "Not All Spaces",
                            value: null,
                            errorText: "Field must not have all spaces.",
                        },

                    ],
                    csp: {
                        autoFocus: false,
                        multiline: false,
                        placeholder: null,
                        label: "Name",
                        disabled: false,
                        size: "small",
                    },
                    ip: {},
                    type: "TextField",
                    requiresConfirmation: false,
                },
                "Status": {
                    id: "Status",
                    enterpriseComponentAttribute: "Status",
                    placement: {
                        "Query": {
                            xs: 12,
                            sm: 6,
                            md: 6,
                            lg: 3,
                            xl: 3
                        }
                    },
                    errors: [],
                    csp: {
                        autoFocus: false,
                        multiline: false,
                        placeholder: null,
                        label: "Status",
                        disabled: false,
                        size: "small",
                    },
                    ip: {},
                    type: "Select",
                    requiresConfirmation: false,
                }
            }
        }
    };
}

export default AdminOrganizationPositionTableApplet;
